import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import React from "react"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"

const TextQuoteBlock = ({ block }) => {
  return (
    <BlockWrapper
      block={block}
      blockWidth="container"
      showHeadline="false"
      className="text-white bg-secondary-700"
    >
      <div className="flex flex-row flex-wrap mt-8 -mx-grid">
        <div className="lg:w-3/5 px-grid">
          <HeadlineEnhanced
            kicker={block.kicker}
            headline={block.headline}
            headlineLevel={block.headline_level}
            subheadline={block.subheadline}
          />
          <Richtext
            className="mt-8 text-white check-list"
            flow="true"
            text={block.text}
          />
          {block.link?.cached_url?.length > 0 && block.link_text?.length > 0 && (
            <Link
              className="mt-8 bg-white btn text-primary hover:text-primary-hover"
              link={block.link}
            >
              {block.link_text}
            </Link>
          )}
        </div>
        <div className="lg:w-2/5 px-grid">
          <div className="p-4 mt-12 bg-white lg:mt-0 rounded-xl">
            <blockquote className="text-center ">
              {block.quote_title?.length > 0 && (
                <span className="block mb-2 text-sm text-center uppercase text-primary">
                  {block.quote_title}
                </span>
              )}
              <div className={`block text-black font-semibold`}>
                <Richtext className="" text={block.quote} />
              </div>
              {block.author?.length > 0 && (
                <footer className="mt-4">
                  <div className="w-16 h-16 mx-auto overflow-hidden rounded-full">
                    <Image
                      className="object-contain w-full h-full"
                      aspectRatio="1by1"
                      image={block.image}
                    />
                  </div>
                  <span className="block font-semibold text-black">
                    {block.author}
                  </span>
                  {block.author_description?.length > 0 && (
                    <>
                      <span className="block text-sm text-gray-500">
                        {block.author_description}
                      </span>
                    </>
                  )}
                </footer>
              )}
            </blockquote>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default TextQuoteBlock
